import './styles/main.scss'
import StateController from './Controllers/StateController'

new StateController();
